import { CIcon } from '~/icons/types'

export const ciRacingBike: CIcon = {
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'M9.168 16.147a4.098 4.098 0 1 1-4.066-4.576 4.234 4.234 0 0 1 1.626.33l-.01.01-.245.407-.246.406h-.01L4.574 15.42a.465.465 0 0 0-.01.482.455.455 0 0 0 .407.246Z'
    },
    {
      d:
        'M9.168 15.201H5.81l1.239-2.014.246-.406.236-.378.01-.02a4.064 4.064 0 0 1 1.626 2.818ZM10.094 16.137v.01h.076a.208.208 0 0 1-.076-.01Z'
    },
    {
      d:
        'm16.674 11.486-.709-1.957-7.705.567h-.01L7.088 7.42l1.474.01a.474.474 0 0 0 .473-.473.46.46 0 0 0-.463-.473l-2.203-.009a.431.431 0 0 0-.19.047.535.535 0 0 0-.122.076l-.038.038a.17.17 0 0 0-.047.066.35.35 0 0 0-.047.104.38.38 0 0 0-.029.142.611.611 0 0 0 .038.189l1.541 3.545-.747 1.22a4.386 4.386 0 0 1 .813.482l.397-.643 1.513 3.46h-.283a3.691 3.691 0 0 1 .028.463 3.843 3.843 0 0 1-.028.473v.01h.926v-.01a.208.208 0 0 0 .076.01h-.076a1.24 1.24 0 0 0 1.04.558 1.255 1.255 0 0 0 1.257-1.248.583.583 0 0 0-.018-.18Zm-4.793 2.968a1.218 1.218 0 0 0-1.655.152l-1.569-3.583 7.63-.568.028.076Z'
    },
    {
      d:
        'M10.17 16.147h-.076v-.01a.208.208 0 0 0 .076.01ZM19.87 11.694a.175.175 0 0 0-.066-.02h.028a.072.072 0 0 1 .038.02ZM21.382 17.603a2.833 2.833 0 0 1-.69.652l-1.938-1.91-2.666.747a2.92 2.92 0 0 1-.293-.907l2.345-.643.359-.104.236-1.03v-.01l.416-1.863a3.071 3.071 0 0 1 .927.208l-.662 2.921Z'
    },
    {
      d:
        'M19.889 11.694a.013.013 0 0 0-.02 0 .175.175 0 0 0-.065-.02h-.02a.12.12 0 0 0-.056-.009 3.454 3.454 0 0 0-.832-.094 3.729 3.729 0 0 0-1.125.17h-.01l-.444-1.22-.265-.728-.312-.888h2.581a.402.402 0 0 1-.047.16.533.533 0 0 1-.274.142 2.129 2.129 0 0 1-.548 0 .453.453 0 0 0-.502.445.468.468 0 0 0 .435.5 2.912 2.912 0 0 0 .804-.018 1.327 1.327 0 0 0 .86-.54 1.784 1.784 0 0 0 .208-1.21.47.47 0 0 0-.463-.425H16.07a.452.452 0 0 0-.388.208.431.431 0 0 0-.056.426l.34.936.71 1.957.217.614a4.095 4.095 0 1 0 4.821 6.543c.01 0 .02-.01.029-.02l.01-.009a4.097 4.097 0 0 0-1.863-6.92Zm1.493 5.909a2.833 2.833 0 0 1-.69.652 3.098 3.098 0 0 1-1.796.567 3.136 3.136 0 0 1-2.808-1.73 2.92 2.92 0 0 1-.293-.907 3.096 3.096 0 0 1 1.428-3.177l.917 2.534.359-.104.236-1.03v-.01l-.643-1.768a2.798 2.798 0 0 1 .804-.114 1.164 1.164 0 0 1 .255.02 3.071 3.071 0 0 1 .927.207 3.163 3.163 0 0 1 1.976 2.921 3.09 3.09 0 0 1-.672 1.939Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'racing-bike',
  type: 'thin'
}
